import React from "react";
import { Flex, Heading } from "@chakra-ui/react";
import colors from "theme/foundations/colors.style";

interface Props {
  categories: any;
  activeIndex: number;
  callback: React.Dispatch<React.SetStateAction<number>>;
}
const Categories: React.FC<Props> = ({
  categories,
  activeIndex,
  callback
}: Props) => {
  return (
    <Flex direction="column" py={8}>
      {categories.map((category: any, index: number): any => (
        <Heading
          key={index}
          as="button"
          size="sm"
          py={3}
          px={6}
          pos="relative"
          textAlign="left"
          whiteSpace="nowrap"
          color={activeIndex == index ? "blue.500" : "white"}
          borderTopWidth={1}
          borderTopColor="gray.600"
          _hover={{
            color: "blue.500",
            cursor: "pointer"
          }}
          onClick={() => {
            callback(index);
          }}
          _after={
            activeIndex == index
              ? {
                  content: `""`,
                  pos: "absolute",
                  width: 0,
                  height: 0,
                  right: 0,
                  borderTop: "10px solid transparent",
                  borderBottom: "10px solid transparent",
                  borderRight: `10px solid ${colors.gray[800]}`
                }
              : {}
          }
        >
          {category.source}
        </Heading>
      ))}
    </Flex>
  );
};

export default Categories;
